import { MediaCarousel } from '@euler/app/components/media/MediaCarousel';
import { PreInspectionResultGroup } from '@euler/app/flows/report/functions/usePreInspectionResults';
import { FontFamily } from '@euler/components/typography';
import { getDefectiveLevelColor } from '@euler/functions/getDefectiveLevel';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useContainerDimensions } from '@euler/functions/useAdaptiveContainerWidth';
import { FacadeSiteConfig } from '@euler/model';
import { memo } from 'react';
import { Text, View } from 'react-native';
import { useTheme } from 'styled-components';
import { PreInspectionReportSection } from './PreInspectionReportSection';

export const PreInspectionResultsView = memo(
  ({
    groups,
    normalSites,
  }: {
    groups: PreInspectionResultGroup[];
    normalSites: FacadeSiteConfig[];
  }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    const { width } = useContainerDimensions();
    const mediaHeight = width * 0.75;

    return (
      <>
        {groups
          .filter(x => x.medias.length > 0)
          .map(group => (
            <PreInspectionReportSection
              key={group.name}
              css={`
                padding: ${rpx(10)}px ${rpx(15)}px;
              `}
            >
              <View
                css={`
                  flex-direction: row;
                  justify-content: space-between;
                  align-items: center;
                  margin-bottom: ${rpx(10)}px;
                `}
              >
                <Text
                  css={`
                    font-family: ${FontFamily.NotoSans.Medium};
                    font-size: ${rpx(18)}px;
                  `}
                >
                  {group.name ?? ''}
                </Text>
                <Text
                  css={`
                    font-family: ${FontFamily.NotoSans.Light};
                    font-size: ${rpx(16)}px;
                    color: ${getDefectiveLevelColor(
                      theme,
                      group.defectiveLevel,
                    )};
                  `}
                >
                  {group.result}
                </Text>
              </View>
              <MediaCarousel
                medias={group.medias}
                css={`
                  height: ${mediaHeight}px;
                  border-radius: ${rpx(10)}px;
                  overflow: hidden;
                `}
              />
            </PreInspectionReportSection>
          ))}
        {normalSites.map(site => (
          <View
            key={site.code}
            css={`
              flex-direction: row;
              justify-content: space-between;
              align-items: center;
              padding: ${rpx(10)}px ${rpx(15)}px;
              background-color: #fff;
              margin-bottom: ${rpx(15)}px;
            `}
          >
            <Text
              css={`
                font-family: ${FontFamily.NotoSans.Medium};
                font-size: ${rpx(18)}px;
              `}
            >
              {site.name}
            </Text>
            <Text
              css={`
                font-family: ${FontFamily.NotoSans.Light};
                font-size: ${rpx(16)}px;
                color: ${theme.colors.defectiveLevel.normal};
              `}
            >
              良好
            </Text>
          </View>
        ))}
      </>
    );
  },
);
